/* eslint-disable react/no-danger */
import React from 'react';
import _ from 'lodash';
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';

export default function FreeZoneFooterOneColumnCTA({ data, id }) {
  const { title, text, link, backgroundImage, backgroundImageMobile, cTAClassName } = data;
  const classNameCta = cTAClassName || 'get-started-cta';

  return (
    <section
      id={id}
      className="pt-[50px] lg:pt-[100px] pb-[20px] lg:pb-[50px] 
    xl:px-0 px-6 md:px-4">
      <BoxedContainer className="relative bg-red overflow-hidden !px-0">
        <div
          className="
        py-[30px] xl:py-[52px]
        px-[21px] md:px-[30px] xl:px-[77px] relative z-10">
          <div className="md:grid grid-cols-12 gap-6 md:gap-7.5">
            <div
              className="col-span-12 
              ltr:md:col-span-7 ltr:lg:col-span-8 
              rtl:md:col-span-6 rtl:lg:col-span-7 
              flex flex-col gap-y-5 md:gap-y-[10px]">
              <div
                dangerouslySetInnerHTML={{ __html: title }}
                className="text-clamp20to25 text-white
              h2-child:leading-1.25 h2-child:!m-0 md:ltr:text-left
              md:rtl:text-right text-center p-child:text-white p-child:!mb-0
              p-child:font-DINMedium h2-child:text-clamp20to25"
              />
              <div
                dangerouslySetInnerHTML={{ __html: text }}
                className="p-child:text-white p-child:text-clamp12to16 p-child:font-normal
              p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
              p-child:rtl:font-GESSTwoDWTCLight md:ltr:text-left
              md:rtl:text-right text-center"
              />
            </div>
            {_.isEmpty(link) || (
              <div
                className="col-span-12 
                ltr:md:col-span-5 rtl:md:col-span-6 
                ltr:lg:col-span-4 rtl:lg:col-span-5 
                flex items-center justify-center md:justify-end pt-6 md:pt-0">
                <Link
                  href={link.url}
                  target={link.target}
                  className={`${classNameCta} 
                  flex justify-center items-center
              rounded-[48px] bg-transparent text-white uppercase 
              ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium
              ltr:tracking-[0.96px] leading-1 h-8 md:h-[49px] text-[11px]
              ltr:md:text-[16px] rtl:md:text-[15px] px-12 md:px-14 py-0 ltr:pt-[3px] md:py-4 
              ltr:md:pt-5 rtl:md:pt-4 border-[1px] 
              md:border-[2px] border-white text-center
              hover:bg-white hover:text-[#CE445B]`}>
                  {link.name}
                </Link>
              </div>
            )}
          </div>
        </div>
        {_.isEmpty(backgroundImage) || (
          <LazyLoadImage
            src={backgroundImage.url}
            width="100%"
            className="absolute inset-0 hidden md:block object-cover h-full w-full"
          />
        )}
        {backgroundImageMobile !== null ? (
          <LazyLoadImage
            src={backgroundImageMobile.url}
            width="100%"
            className="absolute inset-0 md:hidden object-cover h-full w-full bg-blend-multiply"
          />
        ) : (
          ''
        )}
      </BoxedContainer>
    </section>
  );
}
